// Module
var code = `<div class="objectManager-panel-container-table">
    <terceraPanel name='windowPanelBodyQT' />
</div>`;
// Exports
export default code;